export default [
  { path: '/debug/financeables', component: () => import('@/views/debug/Financeables.vue') }
]
